import React from 'react';
import './MenuCategories.css';



const MenuCategories = ({ settings = {} }) => {
  const {
    title = 'Our Menu Categories',
    categories = [
      {
        id: 'main-menu',
        name: 'Main Menu',
        image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=400&fit=crop&crop=center',
        description: 'Authentic Middle Eastern cuisine with traditional flavors',
        button_text: 'VIEW MENU'
      },
      {
        id: 'lunch-menu',
        name: 'Lunch Menu',
        image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&h=400&fit=crop&crop=center',
        description: 'Fresh and healthy lunch options served daily',
        button_text: 'VIEW MENU'
      },
      {
        id: 'desserts',
        name: 'Desserts',
        image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600&h=400&fit=crop&crop=center',
        description: 'Traditional Middle Eastern sweets and modern desserts',
        button_text: 'VIEW MENU'
      },
      {
        id: 'wine-menu',
        name: 'Wine Menu',
        image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&h=400&fit=crop&crop=center',
        description: 'Carefully selected wines to complement our cuisine',
        button_text: 'VIEW MENU'
      }
    ],
    showTitle = true,
    categories_background_image,
    categories_background_color,
    title_color
  } = settings;

  return (
    <section className="menu-categories" style={{background: categories_background_image  ? `url(${categories_background_image}) center/cover no-repeat` : categories_background_color}}>
      <div className="menu-categories__container" >
        {showTitle && (
          <div className="menu-categories__header">
            <h2 className="menu-categories__title" style={{ color: title_color }}>{title}</h2>
          </div>
        )}
        
        <div className="menu-categories__grid">
          {categories.map((category) => (
            <div key={category.id} className="menu-category">
              <div className="menu-category__image-wrapper">
                <img 
                  src={category.image} 
                  alt={category.name}
                  className="menu-category__image"
                  loading="lazy"
                />
                <div className="menu-category__overlay"></div>
              </div>
              
              <div className="menu-category__content">
                <h3 className="menu-category__name">{category.name}</h3>
                {category.description && (
                  <p className="menu-category__description">{category.description}</p>
                )}
                {category.button_link ? (
                  <a 
                    href={category.button_link} 
                    className="menu-category__button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {category.button_text || 'VIEW MENU'}
                  </a>
                ) : (
                  <button className="menu-category__button" disabled style={{ opacity: 0.6, cursor: 'not-allowed' }}>
                    {category.button_text || 'VIEW MENU'}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuCategories;